import type { Context } from 'react';
import { createContext } from 'react';

export interface ReactionAnalyticsContextType {
  actionId: string;
  boardId: string;
  cardId: string;
  listId: string;
  notificationId: string;
  notificationType: string;
}

export const ReactionAnalyticsContext: Context<ReactionAnalyticsContextType> =
  createContext({
    actionId: '',
    boardId: '',
    cardId: '',
    listId: '',
    notificationId: '',
    notificationType: '',
  });
